// Unpublished Work © 2026 Deere & Company.

import React from 'react';
import {LandingPageHeader} from '../components/landing-page/LandingPageHeader';
import LandingPageMainImage from '/assets/landing-page-main-image.png';
import {LandingPageContent} from '../components/landing-page/LandingPageContent';
import {PageFooter} from '../components/landing-page/page-footer/PageFooter';
import {useTheme} from '@deere/isg.component-library';
import {useIsMobile} from '../helpers/use-is-mobile-helper';

export const LandingPage = (): React.ReactElement => {
    const theme = useTheme();
    const isMobile = useIsMobile(800);

    return (
        <div className='bg-black min-h-screen relative'>
            <LandingPageHeader isMobile={isMobile} />
            <div
                className={`flex  ${isMobile ? 'flex-col-reverse' : 'flex-row'} gap-4 ${isMobile ? 'mx-4 h-auto' : 'mx-8 min-h-screen'} pt-[56px] justify-center`}
            >
                <LandingPageContent isMobile={isMobile} />
                <div
                    className={`flex-[50%] content-center font-normal grid gap-y-8  ${!isMobile ? 'max-w-[800px]' : ''}`}
                >
                    <img
                        src={LandingPageMainImage}
                        alt='Landing Page Image'
                        className={`max-w-full max-h-[80vh] ${isMobile ? `m-0` : 'm-4'}`}
                        style={{marginTop: isMobile ? theme.jddcTokens.JddcSpacingMedium : undefined}}
                    />
                </div>
            </div>
            <PageFooter isMobile={isMobile} />
        </div>
    );
};
